module.exports = __webpack_public_path__ + "img/step3.6e0b1f50.jpg";